/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type DisplaySettingsModal_viewer = {
    readonly currencies: ReadonlyArray<string | null> | null;
    readonly intlMvpEnabled: boolean | null;
    readonly isSegmentedIntlUrlsEnabled: boolean | null;
    readonly " $refType": "DisplaySettingsModal_viewer";
};
export type DisplaySettingsModal_viewer$data = DisplaySettingsModal_viewer;
export type DisplaySettingsModal_viewer$key = {
    readonly " $data"?: DisplaySettingsModal_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"DisplaySettingsModal_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DisplaySettingsModal_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currencies",
            "storageKey": null
        },
        {
            "alias": "intlMvpEnabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "intlMVP2022"
                }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"intlMVP2022\")"
        },
        {
            "alias": "isSegmentedIntlUrlsEnabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "segmentedIntlUrls"
                }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"segmentedIntlUrls\")"
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = '9b6c7acabaeb33957c2d4f50fe782375';
export default node;
